<template>
    <div class="tw-flex tw-items-center tw-content-center tw-h-full tw-w-full">
        <div class="form-success tw-text-center tw-ml-auto tw-w-full">
            <h1 class="tw-font-bold tw-text-center tw-pt-6 lg:tw-pt-10 tw-uppercase !tw-text-white">OBRIGADO {{ $store.state.formName }}!</h1>
            <p class="tw-text-center tw-pb-6 lg:tw-pb-10 tw-px-6 lg:tw-px-10 !tw-text-white">Assim que possível será contactado pela nossa equipa de forma a apresentar a nossa melhor proposta.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>

<style lang="scss">
@import '~@/assets/scss/partials/_variables.scss';
@import '~@/assets/scss/partials/_fonts.scss';
.form-success {
    box-shadow: 2px 2px 12px 0 rgba(0,0,0,.1);

    @screen lg {
        box-shadow: none;
    }

    .form-title {
        @apply tw-relative tw-pt-10 tw-pb-3 tw-w-full;
        background-color: $main_color;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
        font-size: 26px;
        color: #fff !important;

        @screen lg {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }
    }

    h1 {
        color: #fff !important;
        color: $main_color;
        font-size: 32px;
        font-family: $font_title;

        @screen lg {
            font-size: 48px;
        }
    }

    p {
        color: #fff !important;
        font-family: $font_title;
        text-transform: uppercase;
        font-size: 23px;
        margin-top: 14px;
        font-weight: 400;
        color: $dark;
    }
}

</style>
